import { useGetOrderDetailsQuery } from '@api/api';
import { BlockContainer, LoadingError, OrderDetails, OrderDetailsSkeleton } from '@components';
import { Box, styled } from '@mui/material';
import React from 'react';

// STYLES
//--------
const OrderDetailsBlockWrapper = styled(Box)``;

// TYPES
//-------
export type OrderDetailsBlockProps = {
  children?: React.ReactNode;
};

// COMPONENTS
//------------
export const OrderDetailsBlock = ({ children }: OrderDetailsBlockProps) => {
  const urlParams = new URLSearchParams(window.location.search);
  const id = urlParams.get('id');
  const { currentData, isLoading, isError, isSuccess } = useGetOrderDetailsQuery(id || '', {
    skip: !id,
  });

  return (
    <BlockContainer>
      <OrderDetailsBlockWrapper className='order-details-block'>
        {isLoading && <OrderDetailsSkeleton />}
        {isError && <LoadingError />}
        {isSuccess && <OrderDetails order={currentData?.data} />}
        {children}
      </OrderDetailsBlockWrapper>
    </BlockContainer>
  );
};
